export default "__VITE_ASSET__BwaD6_fc__"